module.exports = __webpack_public_path__ + "components/flag/static/square/bj-d42a130d09667cfa723e509f3cf8f5f5.svg";